// Extracted from kbd.tsx so the component file only exports components
// (keeps React Fast Refresh boundaries intact).
import { cva } from "class-variance-authority";

export const kbdVariants = cva(
  "select-none rounded border px-1.5 py-px font-mono font-normal text-[0.7rem] shadow-sm disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-accent text-accent-foreground",
        outline: "bg-background text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);
